import { createFileRoute, Link } from '@tanstack/react-router';
import { Button, Card, CardContent, CardDescription, CardHeader, CardTitle } from '@cartcloser/ui';

export const Route = createFileRoute('/')({
  component: LandingPage,
});

function LandingPage() {
  return (
    <main className="mx-auto flex max-w-3xl flex-col gap-8 px-6 py-20">
      <header className="space-y-3">
        <p className="text-sm font-semibold tracking-wide text-primary">CartCloser</p>
        <h1 className="text-4xl font-semibold tracking-tight">
          Give every shopper a product expert
        </h1>
        <p className="text-lg text-muted-foreground">
          A category specialist that narrows the field to the right 2–3 products and explains why
          each one fits — so shoppers buy with confidence instead of bouncing.
        </p>
      </header>

      <Card>
        <CardHeader>
          <CardTitle>Get started</CardTitle>
          <CardDescription>
            Create your store, configure expert agents, and drop the widget into your storefront.
          </CardDescription>
        </CardHeader>
        <CardContent className="flex gap-3">
          <Button variant="outline" asChild>
            <Link to="/signin">Sign in</Link>
          </Button>
        </CardContent>
      </Card>
    </main>
  );
}
